import Hero from "../../frontend/components/Hero";
import CalculatorsImag1 from "../../assets/images/MortgageBorrowCalculator.jpg";
import BorrowCalculator from "../../frontend/components/calculators/MortgageBorrowCalculator";

const MortgageBorrowCalculatorsPage = () => {
  return (
    <div>
      <Hero
        title="Mortgage Borrow"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <BorrowCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default MortgageBorrowCalculatorsPage;
